module.exports = "../../app/cells/components/campaigns/widgets/live_tag_cell.rb";